<template>
  <div class="datamain">
    <Header />
    <div class="dataTop">
      当前大棚：
      <el-select
        v-model="greenhouseId"
        placeholder="请选择"
        style="width: 250px"
        size="large"
        clearable
        @change="getVarietyOptions"
      >
        <el-option v-for="item in greenhouseOptions" :key="item.value" :label="item.label" :value="item.value">
        </el-option>
      </el-select>
    </div>
    <div class="databox-container">
      <div class="databox">
        <div class="left-panel">
          <!-- 左侧组件区域 -->
          <left
            ref="leftComponent"
            :greenhouseId="greenhouseId"
            :varietyOptions="varietyOptions"
            @current-stage-updated="handleCurrentStageUpdated"
          />
        </div>
        <div class="center-panel">
          <!-- 中间组件区域 -->
          <center
            ref="centerComp"
            :greenhouseId="greenhouseId"
            :greenhouseName="greenhouseName"
            :varietyOptions="varietyOptions"
            :currentStageInfo="currentStageInfo"
          />
        </div>
        <div class="right-panel">
          <!-- 右侧组件区域 -->
          <right />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Header from '../Header.vue';
import left from './components/panel/left.vue';
import center from './components/panel/center.vue';
import right from './components/panel/right.vue';
import { baseUrl } from '@/axios/baseUrl';
import axios from 'axios';
export default {
  components: {
    Header,
    left,
    center,
    right,
  },
  data() {
    return {
      greenhouseOptions: [],
      greenhouseName: '',
      greenhouseId: '',
      varietyOptions: [],
      currentStageInfo: {
        name: '暂无',
        inPeriod: false,
        index: 0,
        allCycleDetailOptions: [],
      },
    };
  },
  computed: {
    currentTime() {
      return new Date().toLocaleString('zh-CN');
    },
  },
  created() {
    this.getGreenhouseName();
  },

  methods: {
    // 获取大棚名称
    async getGreenhouseName() {
      const greenhouseRes = await axios.post(baseUrl + '/api/basic/greenhouse/selection');
      if (greenhouseRes.code === 200) {
        this.greenhouseOptions = greenhouseRes.data.map((item) => ({
          label: item.serialNumber,
          value: item.id,
        }));
        this.greenhouseId = this.greenhouseOptions[0].value;
        this.greenhouseName = this.greenhouseOptions[0].label;
        console.log('大棚名称', this.greenhouseName);

        this.getVarietyOptions();
      }
    },
    // 获取草莓品种
    async getVarietyOptions(val) {
      const res = await axios.post(baseUrl + '/api/digital-farming/growth-cycle/list-all', {
        enabled: 1,
        greenhouseId: this.greenhouseId,
      });
      this.varietyOptions = [];
      if (res.code === 200 && res.data.length > 0) {
        console.log('品种', res.data);
        this.greenhouseName = this.greenhouseOptions.find((item) => item.value === val)?.label || '';
        this.varietyOptions = res.data.map((item) => ({
          label: item.varietyName,
          value: item.varietyId,
          details: item.details,
        }));
      }
    },

    // 处理当前生长时期更新事件
    handleCurrentStageUpdated(stageInfo) {
      console.log('更新数据', stageInfo);

      this.currentStageInfo = stageInfo;
    },
  },
};
</script>

<style lang="less" scoped>
@font-face {
  font-family: 'title';
  src: url('../../assets/font/title.ttf');
}

.datamain {
  width: 100%;
  height: 100%;
  position: relative;
  background-color: #030a2e;
  margin: 0 auto;
  overflow: hidden;

  .datamenubox {
    margin: 10px;
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding-left: 10px;

    .datamenuitem {
      padding: 10px 20px;
      color: #fff;
      font-size: 22px;
      cursor: pointer;
      background-image: url('../../assets/img/data/btn.png');
      background-size: 100% 100%;
    }

    .died {
      background-image: url('../../assets/img/data/btned.png');
    }
  }

  .databox {
    margin: 10px;
    background: rgba(0, 11, 47, 0.5);
    box-shadow: inset 0px 0px 20px 0px rgba(0, 124, 255, 0.5);
    border-radius: 0px 0px 0px 0px;
    padding: 10px;
    display: grid;
    grid-template-columns: 1fr 1.37fr 0.94fr;
    gap: 10px;
    overflow: hidden;
    min-height: 0;
    height: calc(100vh - 120px);

    // 保留滚动能力，但隐藏外层滚动条。
    scrollbar-width: none;
    -ms-overflow-style: none;

    &::-webkit-scrollbar {
      display: none;
      width: 0;
      height: 0;
    }
  }

  .left-panel {
    min-height: 0;
    overflow: hidden;
    background: rgba(0, 11, 47, 0.3);
    border-radius: 8px;
    border: 1px solid rgba(0, 124, 255, 0.3);
  }

  .center-panel {
    min-height: 0;
    overflow: hidden;
    background: rgba(0, 11, 47, 0.3);
    border-radius: 8px;
    border: 1px solid rgba(0, 124, 255, 0.3);
  }

  .right-panel {
    min-height: 0;
    overflow: hidden;
    background: rgba(0, 11, 47, 0.3);
    border-radius: 8px;
    border: 1px solid rgba(0, 124, 255, 0.3);
    min-height: 400px;
  }

  // 子模块各自的滚动区域同样隐藏滚动条，鼠标滚轮和触摸滚动仍然有效。
  :deep(.databox *) {
    scrollbar-width: none;
    -ms-overflow-style: none;
  }

  :deep(.databox *::-webkit-scrollbar) {
    display: none;
    width: 0;
    height: 0;
  }

  .test-info {
    padding: 20px;
    color: #fff;

    h3 {
      color: #6cc4ff;
      margin-bottom: 15px;
      text-shadow: 0px 0px 8px #1286ff;
    }

    p {
      margin-bottom: 10px;
      line-height: 1.5;
    }

    ul {
      margin-bottom: 20px;
      padding-left: 20px;

      li {
        margin-bottom: 8px;
        line-height: 1.4;
      }
    }
  }
}

.dataTop {
  width: 100%;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-left: 10px;
  color: #fff;
  font-size: 20px;
  font-weight: 400;
}
</style>
